import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const currencyApiSchema = v.object({
  currencyName: v.string(),
  id: v.string(),
});

export const currencySchema = v.object({
  ...currencyApiSchema.entries,
  ...optionSchema.entries,
});

export const currenciesApiSchema = paginatedSchema(currencyApiSchema);

export type CurrencyApi = v.InferOutput<typeof currencyApiSchema>;
export type CurrenciesApi = v.InferOutput<typeof currenciesApiSchema>;

export type CurrencyFilters = Filters<CurrencyApi>;

export type CurrencyFiltersUpdateApi = FiltersUpdateApi<CurrencyApi>;

export type Currency = Prettify<Option<v.InferOutput<typeof currencySchema>>>;

export type Currencies = Entities<Currency>;
